export const PERMISSION_APP_ACCESS = 'PERMISSION_APP_ACCESS'

export const PERMISSION_MANAGE_COMPANIES = 'PERMISSION_MANAGE_COMPANIES'

export const PERMISSION_MANAGE_SHOPS = 'PERMISSION_MANAGE_SHOPS'

export const PERMISSION_MANAGE_STATS = 'PERMISSION_MANAGE_STATS'

export const PERMISSION_MANAGE_CONVERSION = 'PERMISSION_MANAGE_CONVERSION'

export const PERMISSION_TROUBLESHOOT = 'PERMISSION_TROUBLESHOOT'

export const PERMISSION_MANAGE_CONCEPTS = 'PERMISSION_MANAGE_CONCEPTS'

export const PERMISSION_MANAGE_THEMES = 'PERMISSION_MANAGE_THEMES'

export const PERMISSION_MANAGE_PRODUCT_GROUPS = 'PERMISSION_MANAGE_PRODUCT_GROUPS'

export const PERMISSION_MANAGE_WHOLESALERS = 'PERMISSION_MANAGE_WHOLESALERS'

export const PERMISSION_MANAGE_WARRANTY = 'PERMISSION_MANAGE_WARRANTY'

export const PERMISSION_MANAGE_LICENSES = 'PERMISSION_MANAGE_LICENSES'

export const PERMISSION_CACHE = 'PERMISSION_CACHE'

export const PERMISSION_DEV_SETTINGS = 'PERMISSION_DEV_SETTINGS'

export const PERMISSION_RELEASE_NOTES = 'PERMISSION_RELEASE_NOTES'

export const PERMISSION_MANAGE_TRANSLATIONS = 'PERMISSION_MANAGE_TRANSLATIONS'

export const PERMISSION_MANAGE_BANK_HOLIDAYS = 'PERMISSION_MANAGE_BANK_HOLIDAYS'

export const PERMISSION_MANAGE_REGIONS = 'PERMISSION_MANAGE_REGIONS'

export const PERMISSION_MANAGE_EXTERNAL_GMS = 'PERMISSION_MANAGE_EXTERNAL_GMS'

export const PERMISSION_MANAGE_MESSAGES = 'PERMISSION_MANAGE_MESSAGES'

export const PERMISSION_MANAGE_SHOP_EMPLOYEES = 'PERMISSION_MANAGE_SHOP_EMPLOYEES'

export const PERMISSION_MANAGE_EXTERNAL_SYSTEMS = 'PERMISSION_MANAGE_EXTERNAL_SYSTEMS'

export const PERMISSION_TELESALES = 'PERMISSION_TELESALES'

export const PERMISSION_LESSOR_AND_CONCEPT = 'PERMISSION_LESSOR_AND_CONCEPT'

export const PERMISSION_MANAGE_ROAD_ASSISTANCE = 'PERMISSION_MANAGE_ROAD_ASSISTANCE'

export const PERMISSION_MANAGE_CUSTOMER = 'PERMISSION_MANAGE_CUSTOMER'

export const PERMISSION_NEW_CUSTOMERT_ACQUISITION = 'PERMISSION_NEW_CUSTOMERT_ACQUISITION'

export const PERMISSION_CUSTOMER_PROFILE = 'PERMISSION_CUSTOMER_PROFILE'

export const PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU = 'PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU'

export const PERMISSION_RESET_USER_PROFILE_HAMBURGER_MENU = 'PERMISSION_RESET_USER_PROFILE_HAMBURGER_MENU'

export const PERMISSION_CUSTOMER_FUNCTIONAL_FLAG_MANAGEMENT = 'PERMISSION_CUSTOMER_FUNCTIONAL_FLAG_MANAGEMENT'

export const PERMISSION_CUSTOMER_EMAIL_CONTENT = 'PERMISSION_CUSTOMER_EMAIL_CONTENT'

export const PERMISSION_CUSTOMER_EMAIL_ATTACHMENT = 'PERMISSION_CUSTOMER_EMAIL_ATTACHMENT'

export const PERMISSION_CUSTOMER_PENDING_EMAIL = 'PERMISSION_CUSTOMER_PENDING_EMAIL'

export const MODULE_MANAGEMENT_FLAG_MANAGEMENT = 'MODULE_MANAGEMENT_FLAG_MANAGEMENT'

export const PERMISSION_CUSTOMER_OFFER = 'PERMISSION_CUSTOMER_OFFER'

export const PERMISSION_CUSTOMER_ALERTS = 'PERMISSION_CUSTOMER_ALERTS'

export const PERMISSION_ADMIN_UI_CONFIG = 'PERMISSION_ADMIN_UI_CONFIG'

export const PERMISSION_MANAGE_CONCEPT_CONFIGURATION = 'PERMISSION_MANAGE_CONCEPT_CONFIGURATION'
